import { CustomerFullDTO } from 'app/back-office/shared/models/customer/customer.model';
import { RolesEnum } from '../enums/roles.enum';
import { UserCultureEnum } from '../enums/user-culture.enum.model';
import { AgencyDto } from './agency.model';
import { TenantDTO } from './tenant.model';
import { Shop } from './shop.model';

export class UserInfo {
  id: number;
  tenantStores: TenantStore[];
  externalId: string;
  identityId: string;
  culture: UserCultureEnum;
  name: string;
  email: string;
  customer: CustomerFullDTO;
  agency: AgencyDto;
  roles: Array<string>;
  tenant: TenantDTO;
  storeIds: number[];
  status?: UserStatusEnumDTO;
  mainRole: RolesEnum;

  constructor(s?: Partial<UserInfo>) {
    if (s) {
      Object.assign(this, s);
      // TODO: uncomment this
      this.mainRole = +Object.keys(RolesEnum).find(x => isNaN(Number(RolesEnum[x])) && (this.roles || []).some(el => el === RolesEnum[x]));
      // this.mainRole = RolesEnum.CustomerGuest;// TODO: remove this
      if (s.customer) {
        this.customer = new CustomerFullDTO(s.customer);
      }
      if (s.agency) {
        this.agency = new AgencyDto(s.agency);
      }
    }
  }
}

export class TenantStore  {
  public tenantId: string;
  public tenantName: string;
  public stores: Shop[];
}

export enum UserStatusEnumDTO {
  AwaitingAproval = 0,
  Enabled = 1,
  Disabled = 2
}
